import React from 'react'
import ComapanyDataCertification from '../components/company data list/ComapanyDataCertification'

const CompanyDataListMain = () => {
  return (
    <div>
      <ComapanyDataCertification/>
    </div>
  )
}

export default CompanyDataListMain
